/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractDeleteSchema } from "../../funcs/llmExtractDeleteSchema.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteExtractSchemaRequest$inboundSchema,
};

export const tool$llmExtractDeleteSchema: ToolDefinition<typeof args> = {
  name: "llm-extract-delete-schema",
  description: `Delete extraction schema by ID

Remove a stored extraction schema.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractDeleteSchema(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
